import theme from '@ui/configs/vuetify';

const {
  candidateMaleInferred,
  stageApplication,
  stageAssessment,
  sourceInbound,
  sourceOutbound,
  sourceInternal,
  sourceOther,
  sourceReferral,
  stageScreen,
  stageOffer,
  candidateFemaleInferred,
  candidateOther,
  stageHire,
} = theme.theme.themes.light.colors;

export const insightsColorMap = () => ({
  Inbound: sourceInbound,
  Outbound: sourceOutbound,
  Internal: sourceInternal,
  Referrals: sourceReferral,
  Referral: sourceReferral,
  Other: sourceOther,
  Application: stageApplication,
  Screening: stageScreen,
  Assessment: stageAssessment,
  Offered: stageOffer,
  Hired: stageHire,
  Male: candidateMaleInferred,
  Female: candidateFemaleInferred,
  Unknown: candidateOther,
});
